import { render } from "./ServicesDetailsDataAnalytics.vue?vue&type=template&id=79f111c8"
import script from "./ServicesDetailsDataAnalytics.vue?vue&type=script&lang=js"
export * from "./ServicesDetailsDataAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__